const Config =
    {
        ApiUrl: ''
    };

export default Config;